import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addHoliday,
  deleteHoliday,
  getHoliday,
  setHolidayList,
} from "../../features/setting/settingSlice";
// Datepick
import ja from "date-fns/locale/ja";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import SpinnerComp from "../util/SpinnerComp";
import ReactPaginate from "react-paginate";
import { FaAngleDoubleLeft, FaAngleDoubleRight } from "react-icons/fa";
import { setToken } from "../../features/auth/authSlice";

const Holiday = () => {
  const { token } = useSelector((state) => state.auth);
  const { holidayLoading, holiday, holiday_list } = useSelector(
    (state) => state.setting
  );
  const holidayDate = holiday?.value;

  const dispatch = useDispatch();
  useEffect(() => {
    if (token) {
      dispatch(getHoliday(token))
        .unwrap()
        .then(({ res, newToken }) => {
          if (res.data && res.data.result === "success" && newToken) {
            dispatch(setToken(newToken));
          }
        })
        .catch((error) => {});
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (holidayDate && holiday.error_message !== "token_expired")
      dispatch(setHolidayList(holidayDate));
    // eslint-disable-next-line
  }, [holidayDate]);

  // Add Holidays
  const [holidaySetDate, setHolidaySetDate] = useState(new Date());
  const submitHolidayDate = (e) => {
    e.preventDefault();
    const holidayDateSet = moment(holidaySetDate).format("YYYY/MM/DD");
    const data = { holiday: holidayDateSet };

    dispatch(addHoliday({ data, token }))
      .unwrap()
      .then(({ res, newToken }) => {
        if (res.data && res.data.result === "success") {
          dispatch(getHoliday(token));
          setHolidaySetDate(new Date());
          toast.success("休日が追加されました");
          if (res.data && res.data.result === "success" && newToken) {
            dispatch(setToken(newToken));
          }
        }
      })
      .catch((error) => {});
  };

  // Delete Holidayss
  const onDeleteClick = (holi) => {
    const data = {
      holidays: [holi],
    };
    dispatch(deleteHoliday({ data, token }))
      .unwrap()
      .then(({ res, newToken }) => {
        if (res && res.data.result === "success") {
          dispatch(getHoliday(token));
          toast.success("休刊日が削除されました");
          if (res.data && res.data.result === "success" && newToken) {
            dispatch(setToken(newToken));
          }
        }
      })
      .catch((error) => {});
    setHolidaySetDate(new Date());
  };

  // initial state (local)
  const [selectedDay, setSelectedDay] = useState([]);
  useEffect(() => {
    if (holiday_list && holiday?.result === "success") {
      setSelectedDay(holiday_list[0]);
    }
    // eslint-disable-next-line
  }, [holiday_list]);

  // Check Handler
  const checkHandler = (value) => {
    setSelectedDay((prev) =>
      prev.map((brand) => {
        const temp = { ...brand };
        if (brand.value === value) {
          temp.checked = !temp.checked;
        }
        return temp;
      })
    );
  };

  //   Updating selected Days
  const [holidaySelected, setHolidaySelected] = useState([]);

  useEffect(() => {
    if (selectedDay?.length > 0) {
      const checkedDays = selectedDay.filter((brand) => brand.checked);
      setHolidaySelected(checkedDays.map((days) => days.value));
    }
    // eslint-disable-next-line
  }, [dispatch, selectedDay]);

  // Delete all selected
  const deleteAllSelected = () => {
    const data = {
      holidays: holidaySelected,
    };
    dispatch(deleteHoliday({ data, token }))
      .unwrap()
      .then(({ res, newToken }) => {
        if (res && res.data.result === "success") {
          dispatch(getHoliday(token));
          toast.success("休刊日が削除されました");
          if (res.data && res.data.result === "success" && newToken) {
            dispatch(setToken(newToken));
          }
        }
      })
      .catch((error) => {});
  };

  // Pagination
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(30);
  // Set start and end
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = selectedDay?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(selectedDay?.length / itemsPerPage);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % selectedDay.length;
    // console.log(`Loading items from ${itemOffset} to ${endOffset}`)
    setItemOffset(newOffset);
  };

  return (
    <div>
      {/* Holiday Date Pick */}
      <div className="flex justify-between px-2 items-end py-2">
        <div className="flex flex-col">
          <h1 className="font-semibold py-2">新聞休刊日設定 :</h1>
          <form
            onSubmit={submitHolidayDate}
            className="w-full flex justify-start items-center gap-2"
          >
            <div>
              <DatePicker
                className="w-min h-[36px] outline-none focus:outline-none border-2 border-primary px-2 py-[2px] rounded-[8px]"
                selected={holidaySetDate}
                dateFormat="yyyy/MM/dd"
                locale={ja}
                onChange={(date) => setHolidaySetDate(date)}
              />
            </div>
            <button
              type="submit"
              className="w-[177px] h-[36px] flex justify-center px-4 py-[2px] border-2 border-primary bg-primary text-white font-semibold rounded-[8px]"
            >
              追加
            </button>
          </form>
        </div>
        {holidaySelected.length === 0 ? (
          ""
        ) : (
          <button
            type="button"
            onClick={deleteAllSelected}
            className="px-4 py-[2px] border-2 border-red-700 bg-red-700 text-white "
          >
            選択した日付を削除
          </button>
        )}
      </div>
      {/* End Holiday Date Pick */}

      {/* Holiday Display */}
      <div className="flex gap-2 items-center px-2 pt-2">
        <label htmlFor="items_per_page pr-2">Show </label>
        <select
          name="items_per_page"
          id="items_per_page"
          onChange={(e) => setItemsPerPage(e.target.value)}
          className="bg-white border-[1px] border-black px-[2px] rounded-sm"
        >
          <option value="30">30</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
        <p>entries</p>
      </div>
      {holidayLoading ? (
        <SpinnerComp />
      ) : (
        <div className="w-full relative overflow-x-auto px-2 mt-4">
          <table className="w-full text-left text-black">
            <thead className="text-black bg-gray-50 border-[1px] border-black">
              <tr className="py-12">
                <th className="w-2/12 text-center text-md font-bold"></th>
                <th className="w-6/12 text-center text-md font-bold">
                  新聞休刊日
                </th>
                <th className="w-4/12 text-center text-md font-bold">
                  アクション
                </th>
              </tr>
            </thead>
            <tbody className="text-black bg-gray-50 border-[1px] border-black">
              {currentItems?.map((holi, idx) => (
                <tr
                  key={idx}
                  className="odd:bg-gray-200 even:bg-white hover:bg-gray-300 cursor-pointer"
                >
                  <td className="w-2/12 text-center text-sm font-normal">
                    <input
                      type="checkbox"
                      value={holi.value}
                      checked={holi.checked}
                      onChange={() => checkHandler(holi.value)}
                    />
                  </td>
                  <td className="w-2/12 text-center text-sm font-semibold">
                    {moment(holi.value, "YYYY/MM/DD").format("YYYY-MM-DD")}
                  </td>
                  <td className="w-2/12 text-center text-sm font-normal">
                    <button
                      onClick={() => onDeleteClick(holi.value)}
                      className="bg-red-700 text-white px-2 py-[2px] my-2"
                    >
                      削除
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {/* End Holiday Display */}

      {/* Holiday Pagination */}
      <ReactPaginate
        activeClassName={"flex justify-center items-center text-white "}
        breakLabel={"..."}
        containerClassName={
          "flex w-full max-w-[600px] justify-center items-center mx-auto bg-primary mt-4 text-lg text-gray-700"
        }
        disabledClassName={"text-gray-500"}
        marginPagesDisplayed={2}
        nextClassName={""}
        nextLabel={<FaAngleDoubleRight style={{ fontSize: 18, width: 150 }} />}
        onPageChange={handlePageClick}
        pageCount={pageCount || 0}
        pageClassName={"font-semibold px-2"}
        pageRangeDisplayed={2}
        previousClassName={""}
        previousLabel={
          <FaAngleDoubleLeft style={{ fontSize: 18, width: 150 }} />
        }
      />
      {/* End Holiday Pagination */}
    </div>
  );
};

export default Holiday;
